import React from 'react';
import { computeRemSize } from '@ydistri/theme';
import { CalculationStatisticRouteResponse } from '@ydistri/api-sdk';
import { useTableRouteColumns } from '../columns/useTableRouteColumns';
import { DataTable } from '@ydistri/ds';

interface StatisticsModalTableRouteProps {
  data: CalculationStatisticRouteResponse[] | undefined;
  displayDepartment?: boolean;
}

const PrefilledTableRoute: React.FC<StatisticsModalTableRouteProps> = ({
  data,
  displayDepartment = false,
}) => {
  const columns = useTableRouteColumns(displayDepartment);

  return (
    <DataTable<CalculationStatisticRouteResponse>
      id="predefined-statistics-route-table"
      columns={columns}
      dataSource={data}
      size="small"
      height={computeRemSize(400)}
      showHeader
      showBorder
    />
  );
};

export default PrefilledTableRoute;
